/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Doors_QInputs */



/**
* | output |
* | --- |
* | "At the door" |
*
* @param {Tournament_Wiz_Doors_QInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_doors_q = /** @type {((inputs?: Tournament_Wiz_Doors_QInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Doors_QInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("À l'accueil")
	if (locale === "es") return /** @type {LocalizedString} */ ("En la puerta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Na entrada")
	if (locale === "it") return /** @type {LocalizedString} */ ("All'ingresso")
	return /** @type {LocalizedString} */ ("At the door")
});